import React, { useState, useEffect } from "react";
import Logo from "../../assets/images/pixl_logo_black 1.png";
import { ManageApis } from "../../AppServices/ManageApi.js";
import CustomDropdown from "./CustomDropdown.js";
import ChatWrapper from "./ChatWrapper.js";
import ChatInputField from "./ChatInputField.jsx";
import { getBase64 } from "../../Functions/Utils.js";
import axios from "axios";

const InitialText = `Welcome to Pixl’s AI Chatbot! Whether you need help with automating
document processing, identity verification, or onboarding solutions,
I’m here to provide quick and efficient support. Let me know your
question, and I'll guide you through our AI-powered solutions to
streamline your business processes.`;

function ChatScreen({ toggleLeftPanel, chatbotsettings , onVersionChange, uniqueId, clearChatState, onClearChatHandled}) {
  const [chatMessages, setChatMessages] = useState([]);
  const [showMainChat, setShowMainChat] = useState(false); // New state to switch between SingleChat and MainChat
  const [isTyping, setIsTyping] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uuidValue, setUuidValue] = useState("");
  const [hasAttachment, setHasAttachment] = useState(false);
  const [hasAttachFileOption, setHasAttachFileOption] = useState(true);
  const [hasVoiceOption, setHasVoiceOption] = useState(true);
  const [hasLanguageOption, setHasLanguageOption] = useState(true);
  const [selectedVersion, setSelectedVersion] = useState({
    label: "Multi Source",
    value: "multi_source",
    key: "v6",
    attachOption: ["pdf", "docs"],
  });
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: "English",
    label: "en",
  });

  const VersionOptions = [
    {
      label: "Document Query Assistant",
      value: "Document_Query_Assistant",
      key: "v1",
      attachOption: ["pdf", "docx"],
    },
    {
      label: "Database Assistant",
      value: "Database_Assistant",
      key: "v2",
      attachOption: [],
    },
    {
      label: "Web Insight Assistant",
      value: "Web_Crawl_Assistant",
      key: "v3",
      attachOption: [],
    },
    {
      label: "Customer Support Assistant",
      value: "Customer_Support_Assistant",
      key: "v4",
      attachOption: [],
    },
    {
      label: "Financial Statement Bot",
      value: "Financial_Statement_Bot",
      key: "v5",
      attachOption: ["pdf", "docx"],
    },
    {
      label: "Multi Source",
      value: "multi_source",
      key: "v6",
      attachOption: ["pdf", "docx"],
    },
  ];
  const LanguageOptions = [
    { value: "English", label: "en" },
    { value: "Hindi", label: "hi" },
    { value: "Tamil", label: "ta" },
    { value: "Malayalam", label: "ma" },
    { value: "Telugu", label: "te" },
  ];

  useEffect(() => {
    if (clearChatState) {
      setChatMessages((prev)=>[]);
      setShowMainChat(false);
      setSelectedLanguage({
        value: "English",
        label: "en",
      })
      onClearChatHandled();
    }
  }, [clearChatState, onClearChatHandled]);

  useEffect(() => {
    switch (selectedVersion?.key) {
      case "v1":
        setHasAttachFileOption((prev) => true);
        setHasVoiceOption((prev) => true);
        setHasLanguageOption((prev) => true);
        setUuidValue((prev) => "test");
        break;
      case "v2":
        setHasAttachFileOption((prev) => false);
        setHasVoiceOption((prev) => true);
        setHasLanguageOption((prev) => true);
        setUuidValue((prev) => "");
        break;
      case "v3":
        setHasAttachFileOption((prev) => false);
        setHasVoiceOption((prev) => true);
        setHasLanguageOption((prev) => true);
        setUuidValue((prev) => "");
        break;
      case "v4":
        setHasAttachFileOption((prev) => false);
        setHasVoiceOption((prev) => true);
        setHasLanguageOption((prev) => true);
        setUuidValue((prev) => "");
        break;
      case "v5":
        setHasAttachFileOption((prev) => true);
        setHasVoiceOption((prev) => true);
        setHasLanguageOption((prev) => true);
        setUuidValue((prev) => "test");
        break;
      case "v6":
        setHasAttachFileOption((prev) => true);
        setHasVoiceOption((prev) => true);
        setHasLanguageOption((prev) => true);
        setUuidValue((prev) => "");
        break;
      default:
        setHasAttachFileOption((prev) => false);
        setHasVoiceOption((prev) => false);
        setHasLanguageOption((prev) => false);
        setUuidValue((prev) => "");
        break;
    }
  }, [selectedVersion]);

  const handleUserMessage = async (message, audioData,audioDataWav, attachData) => {
    if (message.trim() === "" && !audioData && attachData?.length === 0) {
      return;
    }
    if (message.trim() === "" && !audioData) {
      return;
    }
    let attachItems = [];
    let attachmentFile= '';
    let attachmentFileType = '';
    if (attachData?.length > 0) {
      for (const item of attachData) {
        const base64File = await getBase64(item); // Wait for base64 conversion
        attachmentFile = base64File.split(",")[1];
        // attachmentFileType = item.name.split('.').pop().toLowerCase();
        attachmentFileType = "Document";
        attachItems.push({
          UploadedInputFileName: item.name,
          UploadedInputFile: base64File,
          UploadedInputFileType: item.type,
        });
      }
    }
    let audioAttachFile= '';
    if(audioDataWav){
      audioAttachFile=  audioDataWav.split(",")[1];
    }
    // Switch to MainChat if this is the first user message
    if (!showMainChat) {
      setShowMainChat(true);
    }
    // Add user message to chat
    if (chatMessages) {
      setChatMessages((prev) => [
        ...prev,
        {
          text: message,
          isBot: false,
          audio: audioData || "",
          attachments: attachItems || "",
        },
      ]);
    } else {
      setChatMessages([
        {
          text: message,
          isBot: false,
          audio: audioData || "",
          attachments: attachItems || "",
        },
      ]);
    }
    setIsTyping(true);
    setIsLoading((prev) => true);
    
    try {
      const reqBody = {
        uuid: uniqueId?.toString() ||"",
        message: message,
        chatbot_type: selectedVersion.value,
        voice_input_file: audioAttachFile || "string",
        language: selectedLanguage.label,
        uploaded_input_file: attachmentFile || "string",
        uploaded_input_type: attachmentFileType || "string",
        clear_conversation_history: false,
      };
      // const reqBody = {
      //   uuid: "",
      //   message: message,
      //   chatbot_type: selectedVersion.value,
      //   voice_input_file:  "string",
      //   language: selectedLanguage.label,
      //   uploaded_input_file:  "string",
      //   uploaded_input_type:  "string",
      //   clear_conversation_history: true,
      // };
      const response = await axios.post(
        global.chatBaseUrl + global.chatbot,
        reqBody
      );
      if (
        response?.data?.status === "success" &&
        response?.data?.detail?.code === 200
      ) {
          if(response?.data?.detail?.msg?.status === "SUCCESS"){
            const botMessage = response?.data?.detail?.msg?.response;
            setIsLoading((prev) => false);
            setChatMessages((prev) => [
              ...prev,
              { text: botMessage, isBot: true, useTypingEffect: true }, 
            ]);
          }else{
            setIsLoading((prev) => false);
            setChatMessages((prev) => [
              ...prev,
              { text: "Sorry, I couldn't understand that.", isBot: true, useTypingEffect: true }, 
            ]);
          }
        
      } else {
        setIsLoading((prev) => false);
        setChatMessages((prev) => [
          ...prev,
          {
            text: "Sorry, I couldn't understand that.",
            isBot: true,
            useTypingEffect: true,
          },
        ]);
      }
    } catch (error) {
      console.error("Error while making the chat API call:", error);
      setIsLoading((prev) => false);
      setChatMessages((prev) => [
        ...prev,
        {
          text: "Sorry, something went wrong. Please try again later.",
          isBot: true,
          useTypingEffect: true,
        },
      ]);
    }
  };

  // Callback to update hasAttachment
  const handleAttachment = (hasAttachmentValue) => {
    setHasAttachment(hasAttachmentValue);
  };

  const handleVersionChange = (version) => {
    if(!(selectedVersion.key == version.key)){
      setChatMessages((prev)=>[]);
      setShowMainChat(false);
      setSelectedVersion(version);
      onVersionChange(version);
    }
  };
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  

  return (
    <>
      <div className="w-100">
        <div className="d-lg-none">
          <div className="align-items-center bg-white d-flex gap-2 pb-2 position-sticky pt-3 px-4 top-0 z-1">
            <i
              className="fas fa-bars font_20 me-2 px_hover_1 cursor-pointer"
              onClick={toggleLeftPanel}
            ></i>
            <img src={Logo} width={50} />
            <span className="font_18 fw_700">AI Chatbot</span>
          </div>
        </div>
        <div className="chat__wrapper w-100 bg-white rounded">
          {chatbotsettings?.enableVersion && (
            <div className="position-absolute ms-2 mt-2 zi_1">
              <CustomDropdown
                dropdownType="version"
                selectedOption={selectedVersion}
                options={VersionOptions}
                onOptionChange={handleVersionChange}
              />
            </div>
          )}
          <ChatWrapper
            type={showMainChat ? "main" : "single"}
            InitialText={InitialText}
            chatMessages={chatMessages}
            hasAttachment={hasAttachment}
            setIsTyping={setIsTyping}
            isLoading={isLoading}
          >
            <ChatInputField
              placeholder={"Ask Anything..."}
              isTyping={isTyping}
              onSendMessage={handleUserMessage}
              hasAttachment={handleAttachment}
              hasAttachFileOption={hasAttachFileOption}
              hasVoiceOption={hasVoiceOption}
              hasLanguageOption={hasLanguageOption}
              selectedLanguage={selectedLanguage}
              languageOptions={LanguageOptions}
              onLanguageChange={handleLanguageChange}
              selectedVersion={selectedVersion}
              uniqueId={uniqueId}
            />
          </ChatWrapper>
        </div>
      </div>
    </>
  );
}

export default ChatScreen;
